const BEFORE_FRAMEWORK_INITIALIZED = '3070';
const FRAMEWORK_INITIALIZED = '3036';

export function rumSendBeforeFrameworkInit() {
    window.Ya?.Rum?.sendTimeMark?.(BEFORE_FRAMEWORK_INITIALIZED);
}

export function rumSendFrameworkInited() {
    window.Ya?.Rum?.sendTimeMark?.(FRAMEWORK_INITIALIZED);
}
